import { render, staticRenderFns } from "./policyTsft4.vue?vue&type=template&id=2fe16c0a"
import script from "./policyTsft4.vue?vue&type=script&lang=js"
export * from "./policyTsft4.vue?vue&type=script&lang=js"
import style0 from "./policyTsft4.vue?vue&type=style&index=0&id=2fe16c0a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports